import React from 'react';
import { Typography } from '@material-ui/core';
import './InputTitle.scss';

const InputTitle = ({ className = '', ...props }) => (
    <Typography
        component="p"
        className={`it-input-label ${className}`}
        {...props}
    >
        {props.children}
    </Typography>
);

export default InputTitle;